import {useEffect} from "react";


export default function useOnloadEffect(block){
    useEffect(block, [])
}